export * from "./types.js";
export * from "./copy.js";
export { calculateAu06, sumRepaymentIncome } from "./calculate.js";
export { fy2025_26 } from "./fy2025-26.js";

import type { FinancialYear } from "../types.js";
import type { Au06RuleSet } from "./types.js";
import { fy2025_26 } from "./fy2025-26.js";

/** Registry of AU-06 rulesets by financial year. Historical years stay
 * registered so re-runs/amendments resolve against the right rules. */
export const AU06_RULESETS: Record<string, Au06RuleSet> = {
  "2025-26": fy2025_26,
};

/** Resolve the AU-06 ruleset for a financial year, or throw if unknown. */
export function au06RulesFor(fy: FinancialYear): Au06RuleSet {
  const rules = AU06_RULESETS[fy];
  if (!rules) {
    throw new Error(`no AU-06 ruleset registered for FY ${fy}`);
  }
  return rules;
}

/** Most recent AU-06 ruleset — the default for live "this year" calcs. */
export const AU06_CURRENT_FY: FinancialYear = "2025-26";
